import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { PolygonElement } from "../polygon-element";
import { PropertyMetadata } from "../../properties/property-types";
import { LevelDesignerElementBase } from "../element-base";
import { Gate } from "./gate";
import { RegisterElement } from "../element-decorator";
import { Barrier } from "../devices/barrier";
import { Camera } from "../devices/camera";
import { TrafficLight } from "../devices/traffic-light";

@RegisterElement()
export class Lane extends PolygonElement {
    layerIndex: number = 2;
    public override TypeName: string = "Lane";
    public override ParentType: string | null = "Gate";
    public override ParentFormGroupName: string | null = "Lanes";

    constructor(formGroup: FormGroup) {
        super(formGroup);
        this.OutlineColor = '#a64ca6';  // Purple
        this.FillColor = 'rgba(166, 76, 166, 0.2)';

        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Barriers')) {
            formGroup.addControl('Barriers', new FormArray([]));
        }
        if (!formGroup.contains('Cameras')) {
            formGroup.addControl('Cameras', new FormArray([]));
        }
        if (!formGroup.contains('TrafficLights')) {
            formGroup.addControl('TrafficLights', new FormArray([]));
        }
        if (!formGroup.contains('LocalControllerId')) {
            formGroup.addControl('LocalControllerId', new FormControl(''));
        }
    }

    public override clone(): Lane {
        return new Lane(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                description: 'Name of the lane',
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'LocalControllerId',
                displayName: 'Controller',
                inputType: { 
                    type: 'form-control-select',
                    formArrayName: 'Controllers',
                    idProperty: 'Id',
                    labelProperty: 'Name'
                },
                description: 'Controller assigned to this lane',
                order: 2,
                category: 'Configuration'
            }
        ];
    }

    public override default(): Lane {
        this.points = [
            { x: 0, y: 0 },
            { x: 2, y: 0 },
            { x: 2, y: 4 },
            { x: 0, y: 4 }
        ];
        return this;
    }
} 
